export enum COUNTER_TYPES {
  INCREMENT_REQUEST = '@counter/INCREMENT_REQUEST',
  INCREMENT_SUCCESS = '@counter/INCREMENT_SUCCESS',
  DECREMENT_REQUEST = '@counter/DECREMENT_REQUEST',
  DECREMENT_SUCCESS = '@counter/DECREMENT_SUCCESS',
}

export interface CounterState {
  readonly value: number;
}
